import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import scaleD from '../lib/scaleD.js';
import styles from './Cardio.scss';
const Cardio = ({ size = 50, color = 'black', speed = 1.5, stroke = 4, bgOpacity = 0.1, }) => {
    const d = 'M0.5,17.2h8.2l3-4.7l5.9,12l7.8-24l5.9,16.7v0h8.2';
    const sizeInt = parseInt(size + '');
    const scaledD = scaleD(sizeInt / 40, d);
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + '',
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsxs("svg", { className: styles.inner, x: "0px", y: "0px", viewBox: `0 0 ${size} ${sizeInt * (25 / 40)}`, height: sizeInt * (25 / 40), width: size, preserveAspectRatio: "xMidYMid meet", children: [_jsx("path", { className: styles.track, strokeWidth: stroke, fill: "none", pathLength: "100", d: scaledD }), _jsx("path", { className: styles.car, strokeWidth: stroke, fill: "none", pathLength: "100", d: scaledD })] }) }));
};
export default Cardio;
